//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "transition-expand-item",
  methods: {
		beforeEnter(element) {
			element.style.opacity = "1";
			element.style.height = "auto";
      element.style.display = "";
		},
    enter(element) {
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      const height = getComputedStyle(element).height;
      element.style.position = null;
      element.style.visibility = "visible";
      element.style.height = 0;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      const height = getComputedStyle(element).height;
      element.style.height = height;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
		afterLeave(element) {
			element.style.opacity = "0";
			element.style.visibility = "hidden";
      element.style.height = "auto";
			setTimeout(() => {element.style.display = ""}, 100);      
		}
  },
};
